import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, FormField, Link, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import DRPicker from '../../../../../components/DRPicker';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCategory, getCookie, getEquipment, getUrlVersion, minutesToHHMM2, setData, setLoading, setParameters } from '../../../../commons/functions';


interface ReportItem {
    id: number;
    name: string;
    flights: number;
    time: number;
    average: number;
}

export const ReportsOpsFuelUsabilityPage = () => {
    const { menu, parameters, data } = useGlobalState();
    useGlobalState();
    const [flights, setFlights] = useState<any[]>();
    const [flightsCons, setFlightsCons] = useState<any[]>();
    const [flightsCategory, setFlightsCategory] = useState<any[]>();
    const [flightsEquipment, setFlightsEquipment] = useState<any[]>();
    const [idCategory, setIdCategory] = useState<number>();
    const [idEquipment, setIdEquipment] = useState<number>();
    const [header, setHeader] = useState("");

    useEffect(() => {
        if (idCategory && idCategory > 0) {
            handleFlightsSearchCategory(idCategory);
        }
    }, [idCategory]);


    useEffect(() => {
        if (idEquipment && idEquipment > 0) {
            handleFlightsSearchEquipment(idEquipment);
        }
    }, [idEquipment]);

    const handleFlightsSearchEquipment = async (id: number) => {
        try {
            setLoading(true)
            let body: any = {
                startDate: parameters.startDate,
                endDate: parameters.endDate,
                idEquipment: id,
                orderBy: "userPilot",
                order: "asc",
                columns: "idUser as id, userPilot as name, 'users' as type, count(idFlight) as flights, sum(delta) as time, FORMAT(ISNULL(max(departureDate),''), 'dd-MM-yyyy') as lastFlight",
                groupBy: "idUser, userPilot",
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlightsEquipment(data.flights);
                setFlights(data.flights.map((item: any) => ({ ...item, average: Math.round(item.time / item.flights) })));
                setHeader("Tripulación");
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleFlightsSearchCategory = async (id: number) => {
        try {
            setLoading(true)
            let body: any = {
                startDate: parameters.startDate,
                endDate: parameters.endDate,
                idCategory: id,
                orderBy: "registration",
                order: "asc",
                columns: "idEquipment as id, registration as name, 'equipments' as type, count(idFlight) as flights, sum(delta) as time, FORMAT(ISNULL(max(departureDate),''), 'dd-MM-yyyy') as lastFlight",
                groupBy: "idEquipment, registration",
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlightsCategory(data.flights);
                setFlights(data.flights.map((item: any) => ({ ...item, average: Math.round(item.time / item.flights) })));
                setHeader("Material");
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleFlightsSearch = async () => {

        setFlightsCategory(undefined);
        setFlightsEquipment(undefined);
        setFlightsCons(undefined);
        setFlights(undefined);
        try {
            setLoading(true)
            let body: any = {
                startDate: parameters.startDate,
                endDate: parameters.endDate,
                orderBy: "category",
                order: "asc",
                columns: "category as name, idCategory as id, count(idFlight) as flights, 'categories' as type, sum(delta) as time, FORMAT(ISNULL(max(departureDate),''), 'dd-MM-yyyy') as lastFlight",
                groupBy: "category, idCategory",
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlightsCons(data.flights);
                setFlights(data.flights.map((item: any) => ({ ...item, average: Math.round(item.time / item.flights) })));
                setHeader("Categoría");
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const [sortingColumn, setSortingColumn] = useState<any>({ sortingField: "name" });
    const [isDescending, setIsDescending] = useState(false);
    const columns = useMemo(() => [
        {
            id: "name",
            header: header,
            cell: (item: any) => {
                if (item.type === "users") {
                    return item.name;
                } else {
                    return (
                        <Link variant="secondary" onClick={() => {
                            if (item.type === "categories") {
                                setIdCategory(item.id);
                            } else if (item.type === "equipments") {
                                setIdEquipment(item.id);
                            }
                        }}>
                            {item.name}
                        </Link>
                    );
                }
            },
            sortingField: 'name',
        },
        {
            id: "flights",
            header: "Vuelos",
            cell: (item: any) => item.flights,
            sortingField: 'flights',
        },
        {
            id: "time",
            header: "Tº total",
            cell: (item: any) => `${minutesToHHMM2(item.time)}`,
            sortingField: 'time',
        },
        {
            id: "average",
            header: "Promedio",
            cell: (item: any) => minutesToHHMM2(Math.round(item.time / item.flights)),
            sortable: true,
            sortingField: 'average',
        },
        {
            id: "lastFlight",
            header: "Último vuelo",
            cell: (item: any) => item.lastFlight,
        }
    ], [flightsEquipment, flightsCategory, flightsCons]);

    const sortedReport = useMemo(() => {
        const data = [...flights || []];
        const { sortingField } = sortingColumn;

        const columnDefinition = columns.find(col => (col as any).sortingField === sortingField) as any;
        const comparator = columnDefinition?.sortingComparator;

        data.sort((a, b) => {
            let result = 0;
            if (comparator) {
                result = comparator(a, b);
            } else if (sortingField) {
                const valA = a[sortingField as keyof ReportItem];
                const valB = b[sortingField as keyof ReportItem];

                // Check if both values are numbers
                if (typeof valA === 'number' && typeof valB === 'number') {
                    result = valA - valB;
                } else {
                    // Fallback for strings
                    const strA = (valA ?? "").toString().toLowerCase();
                    const strB = (valB ?? "").toString().toLowerCase();
                    result = strA.localeCompare(strB);
                }
            }
            return isDescending ? -result : result;
        });

        return data;
    }, [sortingColumn, isDescending, columns, flights]);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s" direction='vertical'>
                    <Header variant="h1" actions={<Favorites />}>Usabilidad</Header>
                    <SpaceBetween size="s" direction='horizontal'>
                        <FormField label="Rango de fechas">

                            <DRPicker
                                start={parameters.startDate}
                                end={parameters.endDate}
                                onConfirm={(startDate, endDate) => {
                                    const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                                    setParameters(updatedParameters);
                                }}
                            />
                        </FormField>
                        <FormField label="&nbsp;">

                            <Button onClick={() => handleFlightsSearch()} style={{ root: btnIconForm }}><Icon path={mdiMagnify} size={1} /></Button>
                        </FormField>
                    </SpaceBetween>
                    {!!flights && (
                        <SpaceBetween size="s" direction='vertical'>
                            <BreadcrumbGroup
                                onClick={(e) => {
                                    console.log(e.detail.item.id)
                                    if (e.detail.item.id === "categories") {
                                        setFlightsCategory(undefined);
                                        setFlightsEquipment(undefined);
                                        setIdCategory(undefined);
                                        setIdEquipment(undefined);
                                        setFlights(flightsCons);
                                    }
                                    if (e.detail.item.id === "equipments") {
                                        setFlightsEquipment(undefined);
                                        setIdEquipment(undefined);
                                        setFlights(flightsCategory);
                                    }
                                }}
                                items={[
                                    { text: "Categorias", href: "#reports/ops/usability", id: "categories" },
                                    ...(idCategory && idCategory > 0 ? [{ text: getCategory(idCategory ?? 0, data).category, href: "#reports/ops/usability", id: "equipments" }] : []),
                                    ...(idEquipment && idEquipment > 0 ? [{ text: getEquipment(idEquipment ?? 0, data).registration, href: "#reports/ops/usability", id: "users" }] : []),
                                ]}
                                ariaLabel="Breadcrumbs"
                            />
                            <Table
                                items={sortedReport} // Pass the SORTED list here
                                sortingColumn={sortingColumn}
                                sortingDescending={isDescending}
                                onSortingChange={(e) => {
                                    setSortingColumn(e.detail.sortingColumn);
                                    setIsDescending(e.detail.isDescending);
                                }}
                                variant='embedded'
                                stickyHeader
                                columnDefinitions={columns || []}

                            />
                        </SpaceBetween>
                    )}
                </SpaceBetween>
            }
        />
    )
};
